import { useState } from 'react'
import IconsTextNavigation from 'components/global/IconsTextNavigation'
import RequestMentorModal from 'pages/Events/Views/Common/Modals/RequestMentorModal'
import { classesEventStore } from 'state/classes/classesStore'

const MentorRequest = () => {
  const { classesData } = classesEventStore(store => ({
    classesData: store.classesData,
  }))
  const [mentorRequestModal, setMentorRequestModal] = useState<boolean>(false)

  return (
    <>
      <div onClick={() => setMentorRequestModal(true)}>
        <IconsTextNavigation
          iconName="MagnifyingGlass"
          heading="Mentor Request"
          isCompleted={classesData?.mentorRequestIds?.length ? true : false}
        />
      </div>
      {mentorRequestModal && (
        <RequestMentorModal
          openModal={mentorRequestModal}
          setOpenModal={setMentorRequestModal}
          reference="class"
          referenceId={classesData._id}
        />
      )}
    </>
  )
}

export default MentorRequest
